module.exports = __webpack_public_path__ + "static/media/promocode-background.880bcc33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promocode-background.png
// module id = 345
// module chunks = 0